/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getOauthProviders,
    getOauthProvider,
    printOauthProvider,
    createOauthProviders,
    updateOauthProviders,
    deleteOauthProviders,
} from "./api.oauth_provider";

const state = {
    page: {},
    form: {},
    oauth_providers: [],
    oauth_provider_options: [],
    selectedOauthProvider: {
        provider_id: null,
        account_id: "",
        oauth_provider_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        oauth_provider_details: [],
    },
    oauth_providers_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_oauth_providers: {
        provider_id: {
            name: "provider_id",
            rules: "trim|integer|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        third_party: {
            name: "third_party",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        service_name: {
            name: "service_name",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        logo: {
            name: "logo",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        client_id: {
            name: "client_id",
            rules: "trim|required",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        org_id: {
            name: "org_id",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        client_secret: {
            name: "client_secret",
            rules: "trim|required",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        scopes: {
            name: "scopes",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        api_base: {
            name: "api_base",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        auth_uri: {
            name: "auth_uri",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        redirect_uri: {
            name: "redirect_uri",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        redirect_auth_uri: {
            name: "redirect_auth_uri",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    oauth_providers: (state) => {
        return state.oauth_providers;
    },
};

// actions
const actions = {
    async fetchOauthProviders({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getOauthProviders({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "oauth_provider_options",
                        with: response.data.oauth_providers,
                    });
                } else {
                    commit("mutate", {
                        property: "oauth_providers",
                        with: response.data.oauth_providers,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchOauthProvider({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getOauthProvider(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedOauthProvider",
                    with: response.data.oauth_provider,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printOauthProvider({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printOauthProvider(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveOauthProvider({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["third_party"] === "undefined" || body["third_party"] == null || body["third_party"] == "") {
                delete body["third_party"];
                response = await createOauthProviders({ body: body, headers: config.headers });
            } else {
                let third_party = body["third_party"];
                delete body["third_party"];
                response = await updateOauthProviders({ body: body, headers: config.headers }, third_party);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteOauthProvider({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteOauthProviders(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    clearOauthProviders(state) {
        state.page = {};
        state.form = {};
        state.oauth_providers = [];
        state.oauth_provider_options = [];
        state.selectedOauthProvider = {
            provider_id: null,
            account_id: "",
            oauth_provider_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            oauth_provider_details: [],
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
